export default __webpack_public_path__ + "static/oslo-71cc6a89e8f584f9a8ee17a8cdc9bbd1.jpg";